import { DateTime } from "luxon";

/**
 * A namespace for day of week instead of an enum.  There is still an enum but it's WeekDay.Day now instead of just DayOfWeek
 * Namespace is useful because you can put functions in it, kind of like a static class and access all the functions in the namespace from a single import statement
 * ------------------------------------
 * Use Example:
 * import { WeekDay } from '@common/models/enums';
 * console.log(WeekDay.fromDateTime(DateTime.now()));
 * ------------------------------------
 * Final Note: DayOfWeekFull was condensed into just WeekDay.Day, you can use the exported getShortNames and getLongNames to get a day of week name, i.e.
 * WeekDay.getShortName(WeekDay.Day.SUNDAY) => 'Sun'
 * WeekDay.getLongName(WeekDay.Day.TUESDAY) => 'Tuesday'
 */
export namespace WeekDay {
    const microNames = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA']; //added for override display
    const shortNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const longNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

    export enum Day {
        Sunday = 0,
        Monday = 1,
        Tuesday = 2,
        Wednesday = 3,
        Thursday = 4,
        Friday = 5,
        Saturday = 6
    }

    export const getMicroName = (day: Day) => microNames[day];
    export const getShortName = (day: Day) => shortNames[day];
    export const getLongName = (day: Day) => longNames[day];

    export const Resources = shortNames.map((title, index) => { return { id: index.toString(), title: title } });
    export const FullResources = longNames.map((title, index) => { return { id: index.toString(), title: title } });

    export const fromDateTime = (date: DateTime) => {
        return date.weekday % 7; //luxon is mon - sun 1 - 7, the only difference between DayofWeek (c#) and luxon is sunday is 7 in luxon and 0 in c#
    }
}
